const WIDGET_SELECTOR = 'ws-block[widget]';

function getParentWidgetByElement(element) {
  if (!element) return null;

  return element.closest(WIDGET_SELECTOR);
}

export default getParentWidgetByElement;
